import { trackExperiment } from "../components/experimentation/utils";
export const setVariant = async (key, variant, trackOnPageLoad = true, brand = 'finn') => {
    if (window.trustVariants) {
        window.trustVariants[key] = variant;
    }
    else {
        window.trustVariants = {
            [key]: variant
        };
    }
    if (trackOnPageLoad) {
        await trackExperiment(key, variant, brand);
    }
};
export const getVariant = (key) => {
    var _a;
    return (_a = window.trustVariants) === null || _a === void 0 ? void 0 : _a[key];
};
//# sourceMappingURL=variants.js.map